import React from 'react';

import {AutoSizedTextArea} from 'app/components/general/AutoSizedTextArea';

import {FieldLastEditStamp} from '../FieldLastEditStamp';
import {TaskFieldSubmitButton} from '../TaskFieldSubmitButton';

import type {StepTaskFieldProps} from '../commonprops';

export const StepTaskTextareaField = ({
  field,
  onSubmit,
  inputValueChanged,
  isSaving,
  progress,
  value,
  initial,
  blocked,
}: StepTaskFieldProps) => (
  <div className="form-group row mb-0">
    {field.label !== '' ? (
      <label
        htmlFor={`step-field-${field.id}`}
        className="col-12 col-form-label pt-0"
      >
        {field.label}
      </label>
    ) : null}

    <form
      className="col-12"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <div className="input-group">
        <AutoSizedTextArea
          id={`step-field-${field.id}`}
          className="form-control"
          onBlur={() => onSubmit()}
          onChange={inputValueChanged}
          disabled={blocked}
          value={value}
        />
        <TaskFieldSubmitButton
          progress={progress}
          isSaving={isSaving}
          value={value}
          initial={initial}
          blocked={blocked}
          onSubmit={onSubmit}
        />
      </div>
      <FieldLastEditStamp progress={progress} />
    </form>
  </div>
);
